import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import BlockLabel from './block-label';

const leftAlign = {
  textAlign: 'left',
};

const padding20 = {
  padding: 20,
  height: 150,
};

const Benchmark = props => {
  const { profile } = props;
  const instagramBenchmarks = _.get(profile, 'instagramBenchmarks');
  const carousel = _.get(instagramBenchmarks, 'CAROUSEL.engagementRate', '-');
  const image = _.get(instagramBenchmarks, 'IMAGE.engagementRate', '-');
  const reels = _.get(instagramBenchmarks, 'REELS.engagementRate', '-');
  return (
    <div style={padding20}>
      <div>
        <h4 style={leftAlign}>
          <div style={{ float: 'right' }}>{carousel}%</div>
            Carousel
        </h4>
      </div>
      <div>
        <h4 style={leftAlign}>
          <div style={{ float: 'right' }}>{image}%</div>
          Image
        </h4>
      </div>
      <div>
        <h4 style={leftAlign}>
          <div style={{ float: 'right' }}>{reels}%</div>
          Reels
        </h4>
      </div>
      <BlockLabel label="Engagement Rates" />
    </div>
  );
};

Benchmark.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default Benchmark;



// WEBPACK FOOTER //
// ./src/containers/summary/components/benchmark.js